import {
    AfterContentInit, ChangeDetectionStrategy,
    Component,
    ContentChildren,
    ElementRef,
    Input, OnChanges,
    OnDestroy,
    OnInit,
    QueryList, SimpleChanges, TemplateRef,
    ViewChild
} from '@angular/core';
import {CommonModule, NgClass} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {customSetInterval} from "@cybfed/core/helpers/overrided-timers";

@Component({
    selector: 'white-label-horizontal-carousel',
    templateUrl: './horizontal-carousel.component.html',
    imports: [
        NgClass,
        CommonModule,
        TranslateModule

    ],
    standalone: true,
    providers: [
    ]
})
export class HorizontalCarouselComponent implements OnInit, OnDestroy, AfterContentInit {
    @Input() showCarets: boolean = false;
    @Input() interval: number = 0;
    @Input() stepWidth: number = 0;
    @Input() count: number = 0;

    @ViewChild('track') trackRef!: ElementRef<HTMLDivElement>;

    // Capture all ng-template elements projected into this component
    @ContentChildren(TemplateRef) contentTemplates!: QueryList<TemplateRef<any>>;

    templates: TemplateRef<any>[] = [];

    currentIndex = 0;
    intervalId: any;

    ngOnInit(): void {
        // Autoplay every 2 seconds
        this.play();

    }

    ngAfterContentInit(): void {

       this.initializeTemplates();

        this.contentTemplates.changes.subscribe(() => {
            this.initializeTemplates();
        });
    }
    private initializeTemplates() {
        //this.templates =   this.contentTemplates.toArray()
        this.templates = []
        for (let i = 1; i <= this.contentTemplates.toArray().length; i++) {
            this.templates.push(this.contentTemplates.toArray()[i])
        }
    }
    private resetCarousel() {
        this.currentIndex = 0;
        this.updateTransform();
        this.play();
    }

    ngOnDestroy(): void {
        this.pause();
    }

    nextSlide() {
        this.currentIndex++;
        this.updateTransform();
    }

    prevSlide() {
        const length = this.templates.length;
        this.currentIndex--;
        if (this.currentIndex < 0) {
            // Jump from second half
            const trackEl = this.trackRef.nativeElement;
            trackEl.style.transition = 'none';
            this.currentIndex = this.currentIndex + length;
            trackEl.style.transform = `translateX(${-this.currentIndex * trackEl.offsetWidth/length}px)`;
            trackEl.getBoundingClientRect(); // force reflow
            trackEl.style.transition = 'transform 0.7s ease-in-out';
        }
        this.updateTransform();
    }

    updateTransform() {
        if(!this.trackRef?.nativeElement){
            return
        }
        const trackEl = this.trackRef?.nativeElement;
        const length = this.templates.length;
        // When currentIndex passes "length", we are into the duplicated section.
        let stepWidth =  trackEl.offsetWidth/length;
        if(this.stepWidth){
            stepWidth = this.stepWidth;
        }
        if (this.currentIndex >= length) {
            // Instantly jump back
            trackEl.style.transition = 'none';
            this.currentIndex = this.currentIndex - length;
            //const left = trackEl.children[this.currentIndex];
            trackEl.style.transform = `translateX(${-this.currentIndex *stepWidth}px)`;
            trackEl.getBoundingClientRect(); // force reflow
            trackEl.style.transition = 'transform 0.7s ease-in-out';
        } else {
            // Normal transition
            trackEl.style.transition = 'transform 0.7s ease-in-out';
            trackEl.style.transform = `translateX(${-this.currentIndex * stepWidth}px)`;
        }
    }

    pause(){
        if (this.intervalId && this.interval) clearInterval(this.intervalId);
    }

    play(){
        if(this.interval){
            this.intervalId = customSetInterval(() => {
                this.nextSlide();
            }, this.interval);
        }
    }
}

